import type { Platform } from './types'
import { createWebPlatform } from './web'
export type * from './types'
export { createWebPlatform } from './web'
export { externalUrl, emailUrl, internalPath, publicUrl, safeFilename } from './links'
export { supportsEmbeddedMedia, requireEmbeddedMedia } from './media'
let platform: Platform = createWebPlatform()
/** Installed before UI/auth modules load; missing native secure storage is an error. */
export function configurePlatform(next: Platform) {
  if (next.kind !== 'web' && !next.secureStorage) throw new Error('Native sessions require OS secure storage')
  platform = next
}
export function getPlatform(): Platform { return platform }
